import { createSlice } from "@reduxjs/toolkit";
import { fetchExportsPreview, fetchExportsHistory } from "../Thunks/exportsThunk";
import { applySubResourceRejected } from "../helpers/asyncResource";

const initialState = {
  preview: {
    data: [],
    summary: null,
    loading: false,
    error: null,
  },
  history: {
    data: [],
    loading: false,
    error: null,
  },
};

export const exportsSlice = createSlice({
  name: "exports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchExportsPreview.pending, (state) => {
        state.preview.loading = true;
        state.preview.error = null;
      })
      .addCase(fetchExportsPreview.fulfilled, (state, action) => {
        state.preview.loading = false;
        state.preview.error = null;
        const payload = action.payload || {};
        state.preview.data = payload.rows ?? [];
        state.preview.summary = payload.summary ?? null;
      })
      .addCase(fetchExportsPreview.rejected, (state, action) => {
        applySubResourceRejected(state.preview, action, "Failed to load export preview");
      })
      .addCase(fetchExportsHistory.pending, (state) => {
        state.history.loading = true;
        state.history.error = null;
      })
      .addCase(fetchExportsHistory.fulfilled, (state, action) => {
        state.history.loading = false;
        state.history.error = null;
        state.history.data = action.payload || [];
      })
      .addCase(fetchExportsHistory.rejected, (state, action) => {
        applySubResourceRejected(state.history, action, "Failed to load export history");
      });
  },
});

export const selectExportsPreviewData = (state) => state.exports.preview.data;
export const selectExportsPreviewSummary = (state) => state.exports.preview.summary;
export const selectExportsPreviewLoading = (state) => state.exports.preview.loading;
export const selectExportsHistoryData = (state) => state.exports.history.data;

export default exportsSlice.reducer;
